import { useEffect, useRef } from 'react';
import { useAnimation, useInView } from 'framer-motion';

/**
 * @param {Object} params
 * @param {Object} params.initial The initial state of the animation.
 * @param {Object} params.animate The final state of the animation.
 * @param {Object} params.transition The transition configuration.
 * @param {Object} params.inViewConfig The configuration object for useInView.
 */
const useFramerAnimation = ({
  initial,
  animate,
  transition,
  inViewConfig,
  disableAnimations,
}) => {
  const variants = { initial, animate: { ...animate, transition } };
  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref, inViewConfig);

  useEffect(() => {
    if (isInView && !disableAnimations) {
      controls.start('animate');
    }
    if (!isInView && !disableAnimations) {
      controls.start('initial');
    }
  }, [controls, isInView, disableAnimations]);

  return { variants, controls, ref };
};

export { useFramerAnimation };
